export default __webpack_public_path__ + "static/media/service-4.f786fb59.png";